export default __webpack_public_path__ + "static/media/Dental-NFT-Coins-1200x500.f82cdfdb.jpg";